/**
 * @module websocket.event.handlers.baggages.baggage-updated
 */
import { store } from '../../../../state/store'
import { setBaggageItemUpdated } from '../../../../state/websocket.slice'

export default function handleBaggageUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleBaggageUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setBaggageItemUpdated(data))
  }
} 